import React from 'react'
import PropTypes from 'prop-types'

const Education = ({size = 16}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.441 1.5h.321c.722 0 1.305 0 1.777.039.486.04.913.123 1.308.324.455.233.85.565 1.153.97a3.333 3.333 0 0 1 1.153-.97c.395-.2.822-.285 1.308-.324.472-.039 1.055-.039 1.777-.039h.321c.352 0 .655 0 .904.02.264.022.526.07.778.198a2 2 0 0 1 .874.874c.129.252.176.514.198.778.02.25.02.553.02.904v6.452c0 .351 0 .654-.02.904a2.035 2.035 0 0 1-.198.778 2 2 0 0 1-.874.874 2.036 2.036 0 0 1-.778.198c-.25.02-.552.02-.904.02H3.441c-.351 0-.655 0-.904-.02a2.036 2.036 0 0 1-.778-.198 2 2 0 0 1-.874-.874 2.037 2.037 0 0 1-.198-.778c-.02-.25-.02-.553-.02-.904V4.274c0-.351 0-.654.02-.904.022-.264.07-.526.198-.778a2 2 0 0 1 .874-.874c.252-.129.514-.176.778-.198.25-.02.553-.02.904-.02Zm3.892 4.933c0-.757 0-1.286-.034-1.697-.033-.403-.094-.635-.184-.81a2 2 0 0 0-.874-.875c-.175-.09-.407-.15-.81-.184-.412-.033-.94-.034-1.698-.034h-.266c-.385 0-.633 0-.822.016-.18.015-.248.04-.28.057a.667.667 0 0 0-.292.291c-.017.033-.042.1-.057.282C2.001 3.667 2 3.916 2 4.3v6.4c0 .384 0 .633.016.821.015.182.04.249.057.282a.667.667 0 0 0 .291.291c.033.017.1.042.281.057.19.015.437.016.822.016h3.866V6.433Zm1.334 5.734V6.433c0-.757 0-1.286.034-1.697.033-.403.094-.635.184-.81a2 2 0 0 1 .874-.875c.175-.09.407-.15.81-.184.412-.033.94-.034 1.698-.034h.266c.385 0 .633 0 .822.016.181.015.248.04.281.057a.667.667 0 0 1 .291.291c.017.033.042.1.057.282.016.188.016.437.016.821v6.4c0 .384 0 .633-.016.821-.015.182-.04.249-.057.282a.667.667 0 0 1-.29.291c-.034.017-.101.042-.282.057a11.35 11.35 0 0 1-.822.016H8.667Z"
        clipRule="evenodd"
      />
      <path fill="#fff" d="M8.667 7.5h6.667v6H8.667z" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13 8.5a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5A.75.75 0 0 1 13 8.5Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M5.333 12.833c0-.368.299-.666.667-.666h3.334a.667.667 0 1 1 0 1.333H6a.667.667 0 0 1-.667-.667ZM14.667 3.5c.368 0 .666.298.666.667V7.5A.667.667 0 1 1 14 7.5V4.167c0-.369.299-.667.667-.667Z"
      />
    </svg>
  )
}

Education.propTypes = {
  size: PropTypes.number,
}

export default Education
